module.exports = __webpack_public_path__ + "03_glasses_black.95622edf.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/momoro/girl/layer4/03_glasses_black.png
// module id = akbl
// module chunks = 0